module.exports = {
  baseUriApi: "YOUR_BASEURIAPI_HERE"
};

//module.exports = {
//   baseUriApi: "https://peam-dev.mav-products.net"
// };